export enum DiscountModalType {
  Credit = 'Credit',
  SpecialDiscount = 'Special Discount',
}

export enum DiscountModalTypeLabelMapping {
  'Credit' = 'Credit',
  'Special Discount' = 'Discount',
}
